import { NextLink } from "cy-fe";
import { ReactNode } from "react";
import { cn } from "cy-fe/src/utils/cn";

export interface LinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

/**
 * Common Link component with default styling for consistency across the app.
 * Uses Next.js Link component for client-side navigation.
 *
 * @param href - The URL to navigate to
 * @param children - The content to display inside the link
 * @param className - Optional CSS classes to override or extend default styles
 */
export function Link({ href, children, className }: LinkProps) {
  return (
    <NextLink
      href={href}
      className={cn("font-semibold underline underline-offset-2", className)}
    >
      {children}
    </NextLink>
  );
}
